import { createContext, useContext } from 'react';

/**
 * True inside GlobalSidePanel. The side panel has one slot and no stack, so a
 * control that would open a panel (AccessField) must not do it from inside
 * one - it would replace the form it lives in.
 */
export const InSidePanelContext = createContext(false);

export const useInSidePanel = (): boolean => useContext(InSidePanelContext);
